export default "__VITE_ASSET__DYxUu3Oa__"